<template>
  <div>
    <a-modal
      v-model="showModal"
      title="Contact Details"
      @ok="() => (showModal = false)"
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
    >
      <template slot="footer">
        <a-button key="cancel" @click="showModal = false">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          @click="save()"
          class="primary-button"
          :style="{ background: getPrimaryColor(), border: getPrimaryColor() }"
          >Add</a-button
        >
      </template>
      <div class="row">
        <div class="col-6 text-left">
          <label for="line_1" class="mb-1 input-label">Number, Street</label>
          <a-input
            placeholder="1400, West Park Street"
            size="large"
            v-model="contact.address_line1"
          />
        </div>
        <div class="col-6 text-left">
          <label for="city" class="mb-1 input-label">City</label>
          <a-input placeholder="Urbana" size="large" v-model="contact.city" />
        </div>
      </div>
      <div class="row">
        <div class="col-6 text-left">
          <label for="state" class="mb-1 input-label">State</label>
          <a-input
            placeholder="Illinois"
            size="large"
            v-model="contact.state"
          />
        </div>
        <div class="col-6 text-left">
          <label for="zip_code" class="mb-1 input-label">Zip Code</label>
          <a-input
            placeholder="61801"
            size="large"
            v-model.number="contact.zip_code"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6 text-left">
          <label for="phone" class="mb-1 input-label"
            >Phone Number<span class="required">*</span></label
          >
          <a-input
            placeholder="Enter Phone Number"
            size="large"
            :defaultValue="contact.phone"
            v-model="contact.phone"
          />
          <div class="error-container" v-if="contact.$error">
            <div class="error-item" v-if="!contact.required">
              Phone Number is required
            </div>
          </div>
        </div>
        <div class="col-6 text-left">
          <label for="email" class="mb-1 input-label">Email Address</label>
          <a-input
            placeholder="abc@example.com"
            size="large"
            v-model="contact.email"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "EditAdvocateContactDetails",
  data() {
    return {
      showModal: false,
      data: null,
      contact: {
        address_line1: null,
        city: null,
        state: null,
        country: null,
        phone: null,
        email: null,
        zip_code: null
      }
    };
  },

  validations: {
    phone: {
      required
    }
  },

  methods: {
    show(data) {
      this.data = data;
      this.contact.phone = data.organization_contact;
      this.contact.email = data.organization_email;
      this.contact.address_line1 = data.organization_location[0].address_line1;
      this.contact.city = data.organization_location[0].city;
      this.contact.state = data.organization_location[0].state;
      this.contact.zip_code = data.organization_location[0].zip_code;
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    save() {
      const payload = {
        address_line1: this.contact.address_line1,
        address_line2: null,
        city: this.contact.city,
        state: this.contact.state,
        zip_code: this.contact.zip_code,
        advocate: {
          organization_contact: this.contact.phone,
          organization_email: this.contact.email
        }
      };
      UserRepository.updateAdvocateOrganisationContact(
        this.authUser.user,
        this.data.organization_location[0].id,
        payload
      )
        .then(res => {
          this.$emit("refresh");
          this.hide();
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.required {
  color: tomato !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/profile/AdvocateContactDetails.vue